import permissions from './permission-list'

export default [
  {
    path: '/affiliate',
    name: 'affiliate',
    component: () => import('@/views/affiliate/index.vue'),
    meta: {
      pageTitle: 'Daftar Affiliator',
      resource: permissions.affiliate,
      action: 'read',
      navActiveLink: 'affiliate',
      breadcrumb: [
        {
          text: 'Daftar Affiliator',
          active: true,
        },
      ],
    },
  },
]
